import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlName, UntypedFormGroup, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { SelectService } from '../select.service';


@Component({
    selector: 'app-select-2',
    templateUrl: './select2.component.html',
    styleUrls: ['../select.component.css'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Select2Component implements OnInit {

  constructor(private selectService: SelectService, private alertService: AlertService, private parentForm: FormGroupDirective) { }

  public selectedList: any[] = [];
  public initialList: any[] = [];
  public validadePreSelected: any[] = [];
  public offlineList: boolean;
  public selected: any;
  public firstChildGroup: UntypedFormGroup;
  private timeoutKeySearch: any = null;

  @Input() list: any[] = []; //Input responsável por gerar o select de maneira offline
  @Input() url: string; //Input responsável por gerar o select de maneira online, ou seja, qualquer pesquisa vai ao backend enviando um searchtext
  @Input() preSelectedlist: any[] = []; //Input responsável por deixar valores préselecionados, é necessário enviar um valor exatamente igual ao que vem nas listas, seja online ou offline.
  @Input() preSelectedBlock: boolean = false; // Input responsável por tornar os valores pré selecionados readonly
  @Input() idField: string; //Input responsável por determinar o campo que é o identificador único da lista (ex: [{id:1, name:"teste"},...] deve ser passado como [idField]="'id'")
  @Input() nameField: string; //Input responsável por determinar o campo que é o label do select que também será usado para filtrar (ex: [{id:1, name:"teste"},...] deve ser passado como [nameField]="'name'")
  @Input() labelField: string; //Nome que aparecerar para o usuário final
  @Input() multiple: boolean = false;//se é multiplo
  @Input() formControlField: string = null;//Se houver formBuilder passar um string do valor child
  @Input() hasNullSelectField: boolean = false;//Se precisar de um campo com valor nulo para deselecionar o select
  @Output() selectedValue = new EventEmitter<any>();//Colocar uma função para receber a lista de objetos selecionados

  //Uso com formcontrolname
  //this.model = this.formBuilder.group({
  //  firstChildGroup: this.formBuilder.group({
  //     valorDoSelectComponent: [''] // and other controls with other validators
  //  })
  //})
  // this.model.get('firstChildGroup').get('valorDoSelectComponent').setValue(values);

  ngOnInit(): void {
    this.firstChildGroup = this.parentForm.form;
    if (this.list && this.list.length > 0) {
      this.initialList = this.list;
      this.selectedList = this.list;
      this.offlineList = true;
    } else {
      this.populateSelect("");
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.preSelectedlist) {
      if (!changes.preSelectedlist.currentValue) return;
      if (changes.preSelectedlist.currentValue !== changes.preSelectedlist.previousValue) {
        
        // ✅ CORREÇÃO: Verifica se é múltiplo antes de atribuir um Array
        if (this.multiple) {
          this.selected = this.preSelectedlist.map(d => d[this.idField]);
        } else {
          // Se for single select, pega apenas o ID do primeiro item
          this.selected = this.preSelectedlist.length > 0 ? this.preSelectedlist[0][this.idField] : null;
        }

        var ids = new Set(this.preSelectedlist.map(d => d[this.idField]));
        this.selectedList = [...this.preSelectedlist, ...this.selectedList.filter(d => !ids.has(d[this.idField]))];
      }
    }
  }

  onChangeSelect(event: any) {
    if (this.multiple) {
      this.preSelectedlist = this.selectedList.filter(c => event.value.includes(c[this.idField]));
      this.selectedValue.emit(this.preSelectedlist);
    } else {
      this.preSelectedlist = this.selectedList.find(c => c[this.idField] == event.value)
      this.selectedValue.emit(this.preSelectedlist);
    }
  }

  populateSelect(searchText: string) {
    if (this.url) {
      this.selectService.getSelectValues(this.url, searchText).subscribe((response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.selectedList = response.list;
        if (this.preSelectedlist && this.preSelectedlist.length > 0) {
          var ids = new Set(this.preSelectedlist.map(d => d[this.idField]));
          this.selectedList = [...this.preSelectedlist, ...this.selectedList.filter(d => !ids.has(d[this.idField]))];
        }
      });
    }
  }

  onKey(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.search(event);
      }
    }, 1000);
  }

  search(value: string) {
    if (this.offlineList) {
      this.selectedList = this.initialList.filter(option => option[this.nameField].toLowerCase().includes(value.toLowerCase()));
      if (this.preSelectedlist.length > 0) {
        var ids = new Set(this.preSelectedlist.map(d => d[this.idField]));
        this.selectedList = [...this.preSelectedlist, ...this.selectedList.filter(d => !ids.has(d[this.idField]))];
      }
    } else {
      this.populateSelect(value);
    }
  }
}
